var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.166 201.333C192.04 201.333 201.666 191.707 201.666 179.833C201.666 167.959 192.04 158.333 180.166 158.333C168.292 158.333 158.666 167.959 158.666 179.833C158.666 191.707 168.292 201.333 180.166 201.333Z",
    fill: "#9a9fa7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.664 359H258.998C313.051 359 340.078 359 356.871 342.207C365.113 333.966 369.31 323.261 371.445 308.108L292.652 221.108C289.473 217.639 284.987 215.667 280.283 215.667C275.831 215.667 271.562 217.436 268.418 220.583L201.664 287.334L170.693 256.365C167.58 253.249 163.357 251.5 158.954 251.5C154.21 251.5 149.695 253.527 146.544 257.073L90.7617 316.685C93.1926 327.447 97.1974 335.614 103.791 342.207C120.584 359 147.611 359 201.664 359Z",
    fill: "#9a9fa7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259 101H201.667C147.613 101 120.586 101 103.793 117.793C87 134.586 87 161.613 87 215.667V244.333C87 298.387 87 325.414 103.793 342.207C120.586 359 147.613 359 201.667 359H259C313.054 359 340.081 359 356.873 342.207C373.666 325.414 373.666 298.387 373.666 244.333V215.667C373.666 161.613 373.666 134.586 356.873 117.793C340.081 101 313.054 101 259 101Z",
    stroke: "#9a9fa7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.166 201.333C192.04 201.333 201.666 191.707 201.666 179.833C201.666 167.959 192.04 158.333 180.166 158.333C168.292 158.333 158.666 167.959 158.666 179.833C158.666 191.707 168.292 201.333 180.166 201.333Z",
    stroke: "#9a9fa7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.499 301.667L292.654 221.108C289.475 217.639 284.985 215.667 280.284 215.667C275.832 215.667 271.564 217.436 268.416 220.583L201.666 287.334L170.695 256.365C167.581 253.249 163.359 251.5 158.956 251.5C154.214 251.5 149.696 253.527 146.546 257.073L94.166 316",
    stroke: "#9a9fa7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.dcfd21610c8f7518a57d61bfd4963faf.svg";
export { ForwardRef as ReactComponent };